import _ from 'lodash';

/**
 * @method compare
 * @description compares two values
 * @param firstVal first value
 * @param secondVal second value
 * @param desc true or false
 * @returns - if firstVal < secondVal returns 1 if desc is true else false
 */
// eslint-disable-next-line complexity
export function compare(firstVal, secondVal, desc?: boolean): number {
  let a = firstVal;
  let b = secondVal;

  if (_.isNull(a) || _.isUndefined(a)) {
    if (_.isNull(b) || _.isUndefined(b)) {
      return 0;
    }

    return 1;
  }

  if (_.isNull(b) || _.isUndefined(b)) {
    return -1;
  }

  if (_.isString(a)) {
    a = a.toLowerCase();
  }

  if (_.isString(b)) {
    b = b.toLowerCase();
  }

  if (a < b) {
    return (desc) ? 1 : -1;
  }

  if (a > b) {
    return (desc) ? -1 : 1;
  }

  return 0;
}

/**
 * @method getComparatorFunction
 * @description returns a comparator function depending on the argument passed
 * @param property object property used to compare
 * @param desc true or false
 * @returns - if a < b returns 1 if desc is true else false
 */
export function getComparatorFunction(property, desc?: boolean): (a: { name: string }, b: { name: string }) => number {
  return function (a, b): number {
    return compare(a[property], b[property], desc);
  };
}

/**
 * @method getAllVendorsWithSizeInfo
 * @description Function to return all vendors having size chart available categorized as product type
 * @param rawData {object} ( data from sizecharts_v3 - if flag on, otherwise form sizecharts_v2)
 * @returns vendorsWithSizeInfoVersion2 {object} (customized according to size recommendation feature)
 */
export function getAllVendorsWithSizeInfo(vendorSizeInfoForEachProductType): any {
  let vendorsWithSizeInfo = {};
  let currentVendor: any = {};
  let tempObj: any = {
    size: []
  };
  let vendorsWithSizeInfoVersion2 = [];
  let subVendorCategory;
  let regex = /[0-9]+(\.0)/;
  let object;
  let sizes;

  // creating custom object by parsing the input rawData

  _.each(vendorSizeInfoForEachProductType, function (vendorData, productType) {
    vendorsWithSizeInfo = {};
    // eslint-disable-next-line consistent-return
    _.each(vendorData, function (vendorSizeInfo, vendor) {
      // when vendor property 'showInAnchorBrands' is "yes", only then it will be shown in anchor dropdown list.
      // else continue the loop - by returning non-false.
      if (vendorSizeInfo.brandProperties && vendorSizeInfo.brandProperties.showInAnchorBrands &&
                    vendorSizeInfo.brandProperties.showInAnchorBrands.toLowerCase() === 'no') {
        return true;
      }

      vendorsWithSizeInfo[vendor] = [];
      _.each(vendorSizeInfo, function (subVendorSizeInfo, subVendor) {
        _.each(subVendorSizeInfo, function (categorySizeInfo, category) {
          if (category === 'defaultCategory') {
            subVendorCategory = '';
          } else {
            subVendorCategory = category;
          }

          sizes = _.keys(categorySizeInfo).length;

          if (sizes === 0) {
          // ignore
          } else {
            tempObj = {};
            tempObj.size = [];

            // eslint-disable-next-line complexity
            _.each(categorySizeInfo, function (sizeData, sizeId) {
              currentVendor = {};

              if (sizeData.sizeQualifier) {
                currentVendor.sizeQualifier = sizeData.sizeQualifier;
              }

              if (sizeData.bustMin && sizeData.bustMax) {
                if (sizeData.bustMin === sizeData.bustMax) {
                  currentVendor.bust = sizeData.bustMin;
                } else {
                  currentVendor.bust = sizeData.bustMin + '-' +
                                            sizeData.bustMax;
                }
              }

              if (sizeData.waistMin && sizeData.waistMax) {
                if (sizeData.waistMin === sizeData.waistMax) {
                  currentVendor.waist = sizeData.waistMin;
                } else {
                  currentVendor.waist = sizeData.waistMin + '-' +
                                            sizeData.waistMax;
                }
              }

              if (sizeData.hipMin && sizeData.hipMax) {
                if (sizeData.hipMin === sizeData.hipMax) {
                  currentVendor.hip = sizeData.hipMin;
                } else {
                  currentVendor.hip = sizeData.hipMin + '-' +
                                            sizeData.hipMax;
                }
              }

              if (sizeData.highHipMin && sizeData.highHipMax) {
                if (sizeData.highHipMin === sizeData.highHipMax) {
                  currentVendor.highHip = sizeData.highHipMin;
                } else {
                  currentVendor.highHip = sizeData.highHipMin +
                                            '-' +
                                            sizeData.highHipMax;
                }
              }

              if (sizeData.girthMin && sizeData.girthMax) {
                if (sizeData.girthMin === sizeData.girthMax) {
                  currentVendor.girth = sizeData.girthMin;
                } else {
                  currentVendor.girth = sizeData.girthMin + '-' +
                                            sizeData.girthMax;
                }
              }

              if (sizeData.lengthMin && sizeData.lengthMax) {
                if (sizeData.lengthMin === sizeData.lengthMax) {
                  currentVendor.length = sizeData.lengthMin;
                } else {
                  currentVendor.length = sizeData.lengthMin +
                                            '-' + sizeData
                    .lengthMax;
                }
              }

              if (sizeData.armHole) {
                currentVendor.armHole = sizeData.armHole;
              }

              if (sizeData.inseamShort) {
                currentVendor.inseamShort = sizeData.inseamShort;
              }

              if (sizeData.inseamRegular) {
                currentVendor.inseamRegular = sizeData.inseamRegular;
              }

              if (sizeData.inseamLong) {
                currentVendor.inseamLong = sizeData.inseamLong;
              }

              if (sizeData.sleeveLength) {
                currentVendor.sleeveLength = sizeData.sleeveLength;
              }

              tempObj.size.push({
                value: sizeId,
                sizeDetails: currentVendor
              });
            });

            object = {
              brand: vendor,
              subVendor: subVendor,
              type: subVendorCategory,
              details: tempObj
            };

            // reg expression check in subVendor Name to exclude them
            if (!(regex.test(object.subVendor))) {
              vendorsWithSizeInfo[vendor].push(object);
            }
          }
        });
      });

      // if brands do not have any size measurements, discard those brands
      if (vendorsWithSizeInfo[vendor].length < 1) {
        delete vendorsWithSizeInfo[vendor];
      }
    });
    vendorsWithSizeInfoVersion2.push({
      productType: productType,
      content: vendorsWithSizeInfo
    });
  });

  return vendorsWithSizeInfoVersion2;
}

/**
 * @method getCollectionHandle
 * @param url url
 * @description Get the collection handle of this particular search.
 * @returns String representing the collection handle.
 */
export function getCollectionHandle(url = window.location.pathname): string {
  let split;

  // eslint-disable-next-line no-useless-escape
  if (!window.location.href.match(/\/collections\/([^\/]*)/gi)) {
    split = url.split('/')[3];

    if (split === 'user') {
      split = 'invalidCollectionhandle';
    }

    return split;
  }

  // eslint-disable-next-line no-useless-escape
  split = url.split(/\/collections\/([^\/]*)/gi);

  if (split.length === 3) {
    return split[1];
  }

  return split;
}
